import React from 'react';
import { ResponsiveContainer, LineChart, CartesianGrid, XAxis, YAxis, Tooltip, Legend, Line } from 'recharts';
import { customColors } from '@utils/gradeUtils.js';

const GradeProgressionChart = ({
  data,
  getGradeLabel,
  climbingStyle,
  gradeSystem
}) => {

  const leftMargin =  (gradeSystem === 'ewbank' ? -12 : 12);

  return (
    <ResponsiveContainer width="100%" height="100%">
      <LineChart 
        data={data.progressData}
        margin={{ top: 0, right: 5, left: leftMargin, bottom: 4 }}
      >
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey="date" 
          tick={{ fontSize: 12 }}
        />
        <YAxis 
          domain={data.yDomain}
          tickFormatter={getGradeLabel}
          ticks={Array.from(
            { length: Math.floor(data.yDomain[1]) - Math.ceil(data.yDomain[0]) + 1 },
            (_, i) => Math.ceil(data.yDomain[0]) + i
          )}
          label={{
            value: 'Grade',
            angle: -90,
            position: 'middle',
            dx: gradeSystem === 'ewbank' ? -10 : -35
          }}
          interval={0}
          tick={{ fontSize: 12 }}
        />
        <Tooltip 
          formatter={(value, name) => [getGradeLabel(value), name]}
        />
        <Legend
          wrapperStyle={{
            fontSize: 12
          }}
        />

        <Line 
          type="stepAfter" 
          dataKey="maxCleanGrade" 
          stroke={customColors.progressMax} 
          name="Max Clean Grade" 
        />
        <Line 
          type="monotone" 
          dataKey="avgCleanGrade" 
          stroke={customColors.progressAvg} 
          name="Average Clean Grade" 
        />
        <Line 
          type="monotone" 
          dataKey="rollingAvgGrade" 
          stroke={customColors.progressRolling} 
          name="12-Month Rolling Average" 
        />
        <Line 
          type="monotone" 
          dataKey="rollingCGPPerDay" 
          stroke="#9333ea" 
          name="Rolling CGP/day" 
        />
        <Line 
          type="monotone" 
          dataKey="rollingCGEPerDay" 
          stroke="#dc2626" 
          name="Rolling CGE/day" 
        />
      </LineChart>
    </ResponsiveContainer>
  );
};

export default GradeProgressionChart;